import React, { useRef, useState } from "react";
import { PutAwayTableWrapper } from "./putAwayTable.style";
import { Button, Input, Space, Table, message } from "antd";
import { SearchOutlined } from "@ant-design/icons";

const PutAwayTable = ({
  dataSource = [],
  columns = [],
  onRowClick = () => {},
  pagination = {},
  setPagination = () => {},
}) => {
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters, confirm, dataIndex) => {
    clearFilters();
    setSearchText("");
    confirm({
      closeDropdown: true,
    });
  };
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={`${selectedKeys[0] || ""}`}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: "block",
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
              display: "flex",
              alignItems: "center",
            }}
          >
            Search
          </Button>
          <Button
            onClick={() =>
              clearFilters && handleReset(clearFilters, confirm, dataIndex)
            }
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? "#1890ff" : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) => text,
  });

  columns = columns.map((item) => {
    if (item.filter) {
      return { ...item, ...getColumnSearchProps(item.dataIndex) };
    }
    return item;
  });
  return (
    <PutAwayTableWrapper>
      <Table
        onRow={(record, rowIndex) => {
          return {
            onClick: () => {
              record.disabled
                ? message.warning("Cannot take this action!")
                : onRowClick(record, rowIndex);
            },
          };
        }}
        rowClassName={(record) => {
          if (record.racked) {
            return "Racked pointer";
          }
          if (!record.statusCode) {
            return "pointer";
          }
          switch (record.statusCode) {
            case 2:
              return "inProgress pointer";
            case 1:
              return "Pending pointer";
            case "Racked":
              return "Racked pointer";

            default:
              return "pointer";
          }
        }}
        width={500}
        scroll={{ x: 650 }}
        dataSource={dataSource}
        pagination={pagination}
        columns={columns}
        onChange={(props) => {
          setPagination(props);
        }}
      />
    </PutAwayTableWrapper>
  );
};

export default PutAwayTable;
